<template></template>
<script>
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import LogoRedirect from '../assets/images/svg/logo-redirect.svg'

Vue.use(VueSweetalert2);

export default {
  name: "Modal",
  props: {
    redirectUrl: {
      type: String,
      // default: "", // 在 footer 有控制 redirectUrl 為非空的字串才會渲染 modal，故先不設定 default
    },
  },
  methods: {
    showAlert() {
      this.$swal({
        imageUrl: LogoRedirect,
        imageWidth: 260,
        imageHeight: 260,
        imageAlt: 'redirect modal logo',
        html: '<span id="redirect-modal-title">全新推出</span><p id="redirect-modal-text">快一點新版點餐系統</p>',
        allowOutsideClick: false,
        confirmButtonText: '立即前往',
        confirmButtonColor: "#F90",
        customClass: {
          container: 'custom-swal-container',
          popup: 'custom-swal-popup',
          image: 'custom-swal-image',
          htmlContainer: 'custom-swal-html-container',
          actions: 'custom-swal-actions',
          confirmButton: 'custom-swal-confirm-button',
        },
      }).then((result) => {
        if (result.isConfirmed && window.location) {
          window.location.href = this.redirectUrl;
        }
      });
    },
    checkIsSafari() {
      const userAgent = navigator.userAgent;
      const vendor = navigator.vendor;

      return /Safari/i.test(userAgent) && !/Chrome|CriOS/i.test(userAgent) && /Apple/i.test(vendor);
    }
  },
  created() {
    this.showAlert()

    setTimeout(() => {
      if (window.location) {
        window.location.href = this.redirectUrl;
      }
    }, 3000);

    // 為了修正在 safari 上 svg 模糊問題，判斷瀏覽器為 Safari 時，將 VueSweetalert2 的 tag img 轉換成 object。
    if (this.checkIsSafari()) {
      // 獲取原來的 img 標籤元素
      const imgElement = document.querySelector(".custom-swal-image");

      // 創建一個新的 object 元素
      const objectElement = document.createElement("object");

      // 設定 object 元素的 data 屬性為 img 標籤的 src 屬性值
      objectElement.setAttribute("data", imgElement.src);

      // 複製其他 img 標籤的屬性到 object 元素
      for (const { name, value } of imgElement.attributes) {
        // 跳過 src 屬性，因為已經設定為 data 屬性了
        if (name !== "src") {
          objectElement.setAttribute(name, value);
        }
      }

      // 將 object 元素替換原來的 img 標籤
      imgElement.parentNode.replaceChild(objectElement, imgElement);
    }

  }
};
</script>

<!-- 自定義 VueSweetalert2 需用全局樣式，故不使用 scoped。 -->
<style>
div.custom-swal-container {
  background: rgba(0, 0, 0, 0.50);
}

.custom-swal-popup {
  position: relative;
  width: 300px;
  height: 306px;
  border-radius: 22.5px;
  padding: 0 15px 15px;
}

.custom-swal-image {
  margin: 0 auto;
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translate(-50%, 0);
}

.swal2-container .custom-swal-html-container {
  margin: 0;
  position: absolute;
  top: 165px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
}

#redirect-modal-title {
  color: #333;
  color: var(--color-gray-1, #333);
  font-size: 24px;
  font-weight: 700;
}

#redirect-modal-text {
  color: #828282;
  font-size: 18px;
  font-weight: 400;
}

/* confirm button */
.custom-swal-actions {
  margin: 0;
  width: 100%;
  align-items: end;
}

.swal2-actions button.custom-swal-confirm-button {
  border-radius: 15px;
  width: 100%;
  height: 40px;
  padding: 0;
  margin: 0;
  font-size: 18px;
  font-weight: 400;
}
</style>
